interface Props {
  [key: string]: any
}
function LockIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 14 14" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M7.00065 8.75V9.91667M3.50065 12.25H10.5007C10.8101 12.25 11.1068 12.1271 11.3256 11.9083C11.5444 11.6895 11.6673 11.3928 11.6673 11.0833V7.58333C11.6673 7.27391 11.5444 6.97717 11.3256 6.75838C11.1068 6.53958 10.8101 6.41667 10.5007 6.41667H3.50065C3.19123 6.41667 2.89449 6.53958 2.67569 6.75838C2.4569 6.97717 2.33398 7.27391 2.33398 7.58333V11.0833C2.33398 11.3928 2.4569 11.6895 2.67569 11.9083C2.89449 12.1271 3.19123 12.25 3.50065 12.25ZM9.33398 6.41667V4.08333C9.33398 3.46449 9.08815 2.871 8.65057 2.43342C8.21298 1.99583 7.61949 1.75 7.00065 1.75C6.38181 1.75 5.78832 1.99583 5.35074 2.43342C4.91315 2.871 4.66732 3.46449 4.66732 4.08333V6.41667H9.33398Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.16667"
      />
    </svg>
  )
}

export default LockIcon
